/**
 * Fires analytics events for inProgress analytics
 * @param {current progress} progress
 * @param {callback to run on defined milestones} onProgress
 * @param {YouTube Video Event} event
 */
const fireVideoProgressEvents = (progress, onProgress, event) => {
  const validProgressValues = [10, 25, 50, 75];
  if (validProgressValues.includes(progress)) {
    onProgress(event, progress);
  }
};
export const YoutubePlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};
const PERCENTAGE_MULTIPLIER = 100;
/**
 * Run an interval to check the progress of the video and fire events at 10%, 25%, 50% and 75%
 * @param {callback to run on defined milestones} onProgress
 * @param {player reference} playerRef
 * @param {YouTube video event} event
 */
export const triggerInProgressVideoIntervals = (onProgress, playerRef, event) => {
  const duration = playerRef.current.getDuration();
  let lastProgress = null;
  const requestAnimationFrameIds = [];
  const frame = () => {
    const currentTime = playerRef.current.getCurrentTime();
    const progress = Math.round(currentTime / duration * PERCENTAGE_MULTIPLIER);
    if (progress !== lastProgress) {
      fireVideoProgressEvents(progress, onProgress, event);
      lastProgress = progress;
    }
    if (currentTime < duration) {
      requestAnimationFrameIds.push(requestAnimationFrame(frame));
    }
  };

  // Cancel any previous animation frames
  requestAnimationFrameIds.forEach(id => cancelAnimationFrame(id));

  // Start a new animation frame
  requestAnimationFrameIds.push(requestAnimationFrame(frame));
  return requestAnimationFrameIds;
};